import { ComponentType, PropsWithChildren } from 'react';

import Loadable from '@townsquare/loadable';

import { SearchSidebarNavigationProps } from '../types';

export const SearchSidebarNavigation: ComponentType<
	PropsWithChildren<SearchSidebarNavigationProps>
> &
	LoadableExport.LoadableComponent = Loadable({
	loader: () =>
		import(/* webpackChunkName: "search-sidebar-navigation" */ './SearchSidebarNavigation'),
	loading: () => null,
});
